export default {
    debug: true,
    counter: 0,
    currentVariantId: 0,
    customPrice: 100,
    activeImageIndex: 0,
    images: [],
    variants: [],
    currentVariant: null,
    gtmItem: {
        item_name: "Flat pack", 
        item_id: '1234', //item id from DB
        price: '270.00', 
        item_brand: 'EVA BLUT',
        item_category: 'ss21', 
        item_variant: 'shades of white', 
        quantity: '1'
        },
    extconf: window.vueAppConf
};
